import type { LocalePack } from './types.js';

/** Vietnamese (Tiếng Việt) */
export const vi: LocalePack = {
  headerTitle: 'Trình chỉnh sửa ảnh',
  headerSubtitle: 'Chỉnh sửa hình ảnh của bạn một cách dễ dàng',
  applyButton: 'Áp dụng',
  cancelButton: 'Đóng',
  undo: 'Hoàn tác',
  redo: 'Làm lại',
  fullscreen: 'Toàn màn hình',
  fit: 'Vừa khung',
  zoomTooltip: 'Thu phóng · +/− · 0 vừa khung · 1 100%',

  emptyStateTitle: 'Thả ảnh hoặc nhấp để tải lên',
  emptyStateSubtitle: 'Hỗ trợ: PNG, JPEG, HEIC',

  calloutLabelText: 'Nhãn',

  tool: {
    select: 'Chọn',
    crop: 'Cắt',
    draw: 'Vẽ',
    eraser: 'Tẩy',
    text: 'Văn bản',
    shapes: 'Hình',
    callout: 'Chú thích',
    filters: 'Bộ lọc',
    adjust: 'Điều chỉnh',
    move: 'Di chuyển',
    pen: 'Bút',
    zoom: 'Thu phóng',
    zoomIn: 'Phóng to',
    zoomOut: 'Thu nhỏ',
    rotateLeft: 'Xoay trái',
    rotateRight: 'Xoay phải',
    flipH: 'Lật ngang',
    flipV: 'Lật dọc',
    reset: 'Đặt lại',
  },

  shape: {
    circle: 'Hình tròn',
    ellipse: 'Hình bầu dục',
    square: 'Hình vuông',
    rectangle: 'Hình chữ nhật',
    arrow: 'Mũi tên',
    polyline: 'Đường',
  },

  filter: {
    none: 'Nguyên bản',
    grayscale: 'Đen trắng',
    sepia: 'Nâu đỏ',
    vintage: 'Cổ điển',
    cool: 'Lạnh',
    warm: 'Ấm',
    invert: 'Đảo màu',
  },

  props: {
    title: {
      draw: 'Vẽ',
      eraser: 'Tẩy',
      text: 'Văn bản',
      crop: 'Cắt',
      shapes: 'Hình',
      callout: 'Chú thích',
      filters: 'Bộ lọc',
      adjust: 'Điều chỉnh',
      move: 'Di chuyển',
    },
    aspectRatio: 'Tỷ lệ khung hình',
    applyCrop: 'Áp dụng cắt',
    cancel: 'Hủy',
    shape: 'Hình',
    preset: 'Cài đặt sẵn',
    resetEffects: 'Đặt lại hiệu ứng',
    resetAdjustments: 'Đặt lại điều chỉnh',
    deleteSelected: 'Xóa mục đã chọn',
    colors: 'Màu sắc',
    recent: 'Gần đây',
    customColor: 'Màu tùy chỉnh',
    brushSize: 'Cỡ cọ',
    strokeWidth: 'Độ dày nét',
    opacity: 'Độ mờ',
    eraserSize: 'Cỡ tẩy',
    fontSize: 'Cỡ chữ',
    brightness: 'Độ sáng',
    contrast: 'Độ tương phản',
    saturation: 'Độ bão hòa',
    blur: 'Làm mờ',
    quickActions: 'Thao tác nhanh',
    hintMove:
      'Kéo để di chuyển · véo hoặc cuộn để thu phóng · chọn công cụ để bắt đầu.',
    hintEraser: 'Chạm hoặc kéo lên chú thích để xóa.',
  },
};
